module.exports = __webpack_public_path__ + "static/media/replace-driver.36c4551c.svg";